import type { Report } from 'powerbi-client';

export async function captureBookmarkState(
  report: Report | null
): Promise<string | null> {
  if (!report) return null;
  const captured = await report.bookmarksManager.capture({ allPages: true });
  return captured.state ?? '';
}
